<template>
    <div @click="exportData" class="items-center text-xs lg:text-sm btn btn-sm text-blue-600 hover:text-blue-400">
        <span class="mr-1">Export Data</span>
        <i class="fas fa-table"></i>
    </div>
</template>

<script setup>
import { inject } from 'vue';

const eventBus = inject('eventBus');

const props = defineProps({
    fileName: String
});

const exportData = () => {
    eventBus.emit('exportToCSV', props.fileName); // Use the event bus's emit method
};
</script>
